export default (node) => {
  const helpButton = node.querySelector('[data-help-button]');
  const helpMenu = node.querySelector('[data-help-menu]');

  const toggleHelpMenu = () => {
    helpMenu.classList.toggle('hidden');
    helpMenu.classList.toggle('border-solid', 'border-2', 'border-gray-90');

    if (!helpMenu.classList.contains('hidden')) {
      document.dispatchEvent(new CustomEvent('localize-menu:close'));
    }
  };

  const closeMenu = () => {
    helpMenu.classList.add('hidden');
  };

  const handleClickOutside = (event) => {
    if (
      helpMenu &&
      !helpMenu.classList.contains('hidden') &&
      !helpMenu.contains(event.target) &&
      !helpButton.contains(event.target)
    ) {
      closeMenu();
    }
  };

  const init = () => {
    if (helpButton) helpButton.addEventListener('click', toggleHelpMenu);
    document.addEventListener('click', handleClickOutside);
    document.addEventListener('help-menu:close', closeMenu);
  };

  init();
};
